/**
 * Blog metadata for listing cards. Full content lives in BlogPost keyed by `slug`.
 *
 * Primary URL: /blog/{slug} — slug is kebab-case (e.g. train-the-mind).
 * `getBlogPostByIdentifier` also accepts numeric id for backwards compatibility.
 */
export const blogPosts = [
  {
    id: 1,
    slug: 'train-the-mind',
    title: 'Train the Mind That Trains the Machine',
    excerpt:
      'Why logical problem solving is the most underrated skill in the AI era — and how sharpening your thinking makes you exponentially better at working with AI.',
    readTime: '8 min read',
    tags: ['Software Engineering', 'Cognition', 'AI & the Human Mind'],
    /** Optional rich hero (title lines, subtitle, meta) — used by BlogPost when present */
    hero: {
      titleLine1: 'Train the Mind That',
      titleLine2Italic: 'Trains the Machine',
      subtitle:
        'Why logical problem solving is the most underrated skill in the AI era — and how sharpening your thinking makes you exponentially better at working with AI.',
      metaLine: '8 min read · For Software Engineers · Cognitive Fitness',
    },
  },
];

/** Resolve a post by numeric id (e.g. "1") or slug (e.g. "train-the-mind"). */
export function getBlogPostByIdentifier(identifier) {
  if (identifier == null || identifier === '') return undefined;
  const s = String(identifier).trim();
  if (/^\d+$/.test(s)) {
    return blogPosts.find((b) => String(b.id) === s);
  }
  return blogPosts.find((b) => b.slug === s);
}

/** @deprecated use getBlogPostByIdentifier */
export function getBlogBySlug(slug) {
  return blogPosts.find((b) => b.slug === slug);
}
